import { useState, useEffect, useRef } from "react";
import { API } from "../backend";
import axios from "axios";
import ButtonLoading from '../components/Loder/buttonLoading'
import FullscreenIcon from '@material-ui/icons/Fullscreen';

function Basic() {
  const [chatboxVisible, setChatboxVisible] = useState(false);
  const [chatLog, setChatLog] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false)


  const toggleChatbox = (message) => {
    setChatLog([])
    message = ''
    sendMessageToRasa(message)
    setChatboxVisible(!chatboxVisible);
  };
  
  const containerRef = useRef(null);

  const displayUserMessage = (message) => {
    const userMessage = { sender: 'user', text: message };
    setChatLog(prevChatLog => [...prevChatLog, userMessage]);
  };
  const displayBotMessage = (message, buttons) => {
    try {
      const botMessage = { sender: 'bot_reply', text: message, button: buttons };
      setChatLog(prevChatLog => [...prevChatLog, botMessage]);
      if (message.sender !== 'user') {
        setIsLoading(false); // Ensure that setIsLoading is called to set the state back to false
      }
    } catch (e) {
      setIsLoading(false); // Ensure that setIsLoading is called to set the state back to false
    }
  };

  useEffect(() => {

    if (containerRef && containerRef.current) {
      const element = containerRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth"
      })
    }

  }, [containerRef, chatLog])

  const sendMessageToRasa = async (message) => {
    try {
      setIsLoading(true)
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      const response = await axios.post(`${API}chat/chat_with_bot/`,
        {
          user_message: message
        },
        config,
      )
      const data = await response.data;
      if (data.bot_reply) {
        setIsLoading(false); // Set loading to false when the API response is received
        displayBotMessage(data.bot_reply, data.choice);
      }
      return data;
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleButtonPayload = (payload) => {
    sendMessageToRasa(payload);
  };

  const handleSendMessage = (event) => {
    if (event.keyCode === 13) {
      const message = userInput.trim();
      if (message !== "") {
        displayUserMessage(message);
        sendMessageToRasa(message);
        setUserInput("");
      }
    }
  };

  const handleScreen = () => {
    const chatbox = document.querySelector('.chatbox');

    if (!document.fullscreenElement) {
      if (chatbox.requestFullscreen) {
        chatbox.requestFullscreen();
      } else if (chatbox.webkitRequestFullscreen) { /* Safari */
        chatbox.webkitRequestFullscreen();
      } else if (chatbox.msRequestFullscreen) { /* IE11 */
        chatbox.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
    }
  }

  return (
    <div>
      <div className="container containerm " >
        <>
          <div 
          className="chat-icon"
            onClick={toggleChatbox}
          >
            <img src="/static/assets/img/curved-images/Ask_Athena_Icon-removebg-previews.png" alt="Ask Athena" style={{ width: '100%', height: '100%', borderRadius:'28%' }} /> {/* Adjust the size according to your needs */}
            {/* Ask Athena */}
          </div>
          {chatboxVisible && (
            <div className="chatbox" >
              <div className="chatbox-header">
              Ask Athena
                <span className="fullscreen-icon cursor-pointer"
                  style={{ position: 'absolute', right: '35px', top: '15px' }}
                  onClick={handleScreen}>
                  <i>
                    <FullscreenIcon />
                  </i>
                </span>
                <span className="close-icon cursor-pointer"
                  onClick={toggleChatbox}
                >
                  <i className="fa fa-times"></i>
                </span>
              </div>
              <div className="chatbox-body" ref={containerRef} style={{ overflowY: 'auto', flex: 1 }}>
                {chatLog.map((message, index) => (
                  <p key={index}
                    className={`chatbox-message ${message.sender === "user" ? "sent" : "received"
                      }`}
                  >
                    {message.text === undefined ?
                      "" :
                      <span className="message-content" style={{ fontSize: 'smaller' }}>
                        {message.text.split('\n').map((text, index) => (
                          <span key={index}>
                            {text}
                            <br /></span>
                        ))}</span>
                    }

                    {message.buttons && message.buttons.length > 0 && (
                      <div className="button-container">
                        {message.buttons.map((button, buttonIndex) => (
                          <button
                            key={buttonIndex}
                            onClick={() => handleButtonPayload(button.payload)}
                          >
                            {button.title}
                          </button>
                        ))}
                      </div>
                    )}
                    {message.list && message.list.length > 0 && (
                      <ul className="bot-list message-content">
                        {message.list.map((item, itemIndex) => (
                          <li className="forlistchatbot" key={itemIndex}>{item}</li>
                        ))}
                      </ul>
                    )}
                  </p>
                ))}
                {isLoading && chatLog.length > 0 && chatLog[chatLog.length - 1].sender === 'user' && (
                  <p className="chatbox-message received message-content" style={{ fontSize: 'smaller' }} ><ButtonLoading color="#808080" size={10}/></p>
                )}
              </div>
              <div className="chatbox-controls" style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                <input
                  type="text"
                  className="chatbox-input"
                  placeholder="Type your message..."
                  value={userInput}
                  onChange={(event) => setUserInput(event.target.value)}
                  onKeyDown={handleSendMessage}
                />
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
}

export default Basic;
